import { render, staticRenderFns } from "./create_singles_politely.vue?vue&type=template&id=fb161dac&scoped=true"
import script from "./create_singles_politely.vue?vue&type=script&lang=js"
export * from "./create_singles_politely.vue?vue&type=script&lang=js"
import style0 from "./create_singles_politely.vue?vue&type=style&index=0&id=fb161dac&prod&lang=scss&scoped=true"
import style1 from "./create_singles_politely.vue?vue&type=style&index=1&id=fb161dac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb161dac",
  null
  
)

export default component.exports